module.exports = __webpack_public_path__ + "img/129.a244ad5b.jpg";